import axios from 'axios'
import { useAuthStore } from '@/stores/useAuthStore'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-type': 'application/json',
  },
})

http.interceptors.request.use(config => {
  const authStore = useAuthStore()
  const accessToken = authStore.token
  if (accessToken && !config.headers.has('Authorization')) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})

export default http

export const isHttpUrl = s => typeof s === 'string' && /^https?:\/\//i.test(s)
